import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Carousel from '@nerdwallet/react-carousel';
import { Impression } from '@nerdwallet/analytics/react/impression';
import TestimonialTile from './testimonial-tile';
import { HOMEPAGE as analyticsBase } from '../../../lib/analytics-constants';

import styles from './testimonials.module.less';

const Testimonials = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, nav) => (
    <TestimonialTile {...tile} key={`item-${nav}`} />
  ));

  return (
    <Impression
      entityName={analyticsBase.entity_names.testimonials}
      payload={{ section_name: analyticsBase.section_name }}
    >
      <div className={styles.testimonialsContainer}>{renderedTiles}</div>
      <div>
        <Carousel
          id="testimonials"
          entityName="testimonials"
          decorateNav={false}
          enableDotNavigation
          arrows={false}
          dots
          inactiveDotColor="#000000"
          activeDotColor="#008255"
          slidesToShow="1.3"
          className={styles.testimonialsCarousel}
        >
          {renderedTiles}
        </Carousel>
      </div>
    </Impression>
  );
};

Testimonials.displayName = 'Testimonials';

Testimonials.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(TestimonialTile.propTypes)),
};

export default Testimonials;
